export default "__VITE_ASSET__DuXJH4t$__"